export interface ScannedItem {
  file?: File;
  relativePath: string;
  isDirectory: boolean;
}

export const scanEntry = async (entry: any, path = ''): Promise<ScannedItem[]> => {
    if (!entry) return [];
    
    if (entry.isFile) {
        return new Promise((resolve) => {
            entry.file((file: File) => {
                if (file) {
                    resolve([{ file, relativePath: path + entry.name, isDirectory: false }]);
                } else {
                    resolve([]);
                }
            }, (err: any) => {
                console.warn('Failed to get file from entry', err);
                resolve([]);
            });
        });
    } else if (entry.isDirectory) {
        const currentDir: ScannedItem = { 
            relativePath: path + entry.name, 
            isDirectory: true 
        };

        const dirReader = entry.createReader();
        const entries: any[] = [];
        
        const readEntries = async (): Promise<any[]> => {
            return new Promise((resolve, reject) => {
                dirReader.readEntries((results: any[]) => {
                    if (results.length) {
                        entries.push(...results);
                        resolve(readEntries());
                    } else {
                        resolve(entries);
                    }
                }, (err: any) => {
                    console.warn('Failed to read dir entries', err);
                    resolve([]); 
                });
            });
        };

        try {
            await readEntries();
        } catch (e) {
            console.warn('Error reading dir entries', e);
        }
        
        const tasks = entries.map(e => scanEntry(e, path + entry.name + '/'));
        const results = await Promise.all(tasks);
        // Return current directory PLUS all its children
        return [currentDir, ...results.flat()];
    }
    return [];
};

export const processDropItems = async (items: DataTransferItemList): Promise<ScannedItem[]> => {
    const promises: Promise<ScannedItem[]>[] = [];
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === 'file') {
            const entry = item.webkitGetAsEntry();
            if (entry) {
                promises.push(scanEntry(entry));
            } else {
                const file = item.getAsFile();
                if(file) promises.push(Promise.resolve([{ file, relativePath: file.name, isDirectory: false }]));
            }
        }
    }
    const results = await Promise.all(promises);
    return results.flat();
};

export const formatSize = (bytes: number) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

export const formatDate = (ts: number) => new Date(ts).toLocaleString();


